export const GUEST_PLAN_FILTER_EVENT = 'canvas-agent:guest-plan:filter';
export const GUEST_PLAN_FOCUS_EVENT = 'canvas-agent:guest-plan:focus';
export const GUEST_PLAN_CREATE_MODAL_EVENT =
	'canvas-agent:guest-plan:create-modal';
export const GUEST_PLAN_EDIT_MODAL_EVENT =
	'canvas-agent:guest-plan:edit-modal';
export const GUEST_PLAN_DELETE_MODAL_EVENT =
	'canvas-agent:guest-plan:delete-modal';
